'use client';
import { createProps, splitProps } from '@chakra-ui/utils';

const checkboxProps = createProps()([
  "aria-describedby",
  "aria-invalid",
  "aria-label",
  "aria-labelledby",
  "defaultChecked",
  "id",
  "isChecked",
  "isDisabled",
  "isFocusable",
  "isIndeterminate",
  "isInvalid",
  "isReadOnly",
  "isRequired",
  "name",
  "onBlur",
  "onChange",
  "onFocus",
  "tabIndex",
  "value"
]);
const splitCheckboxProps = (props) => {
  return splitProps(props, checkboxProps);
};

export { checkboxProps, splitCheckboxProps };
